import {
  styled, rem
} from 'config/stitches.config'

import Container from '@/UI/Container'
import { StyledSectionContent } from '@/Section/Container/styles'

export const StyledStandardModal = styled('div', {
  display: 'block',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 10,
  height: '100%',
  width: '100%',
  opacity: 0,
})

export const StyledStandardModalContainer = styled('div', {})

export const StyledStandardModalClose = styled('button', {})

export const StyledMenuModalContainer = styled(StyledSectionContent, {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  paddingTop: rem(128),
  paddingBottom: rem(64),
  alignItems: 'flex-start',
})

export const StyledSearchModalContainer = styled(Container, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingY: 0,
  height: '100%',
})

export const StyledFormModalContainer = styled(Container, {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  columnGap: '$4',
  color: '$white',
  paddingY: rem(44),

  '.SuccessMessage, button': { flexShrink: 0 },
})

export const StyledTextContentModalContainer = styled('div', {
  backgroundColor: '#fff',
  height: '90%',
  maxWidth: '80%',
  width: ' 100%',
  margin: '0 auto',
  borderRadius: '30px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
  position: 'relative',
  overflow: 'hidden',

  '@lg': { width: '60%', },

  h3: {
    fontWeight: '500',
    fontSize: rem(48),
    lineHeight: '100%',
    letterSpacing: '-2%',
    marginY: rem(24),
  },

  p: {
    fontWeight: '400',
    fontSize: rem(18),
    lineHeight: rem(20),
    letterSpacing: '-2%',
  },

  button: { all: 'unset', },

  '.close-button': {
    position: 'absolute',
    borderRadius: '100px',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    background: 'rgba(0, 0, 0, 0.15)',
    backdropFilter: 'blur(8px)',
    top: '1rem',
    right: '1rem',
    zIndex: 2,
    justifyContent: 'center',
    display: 'flex',
    padding: '0.75rem'
  },
})


export const StyledTextContentModalWrapper = styled('div', {
  overflow: 'auto',
  height: '100%',
  '@lg': { paddingBottom: '4rem' }
})

export const StyledTextContentModalImg = styled('div', {
  position: 'relative',
  width: '100%',
  height: '150px',
  'img': {
    width: '100%', height: '100%',
    objectFit: 'cover',
    objectPosition: 'top center',
  },
  '@lg': { height: '400px', }
})

export const StyledTextContentModalContent = styled('div', {
  paddingX: '1rem',
  '@lg': { paddingX: '4rem' }

})
